import { ArrowUp } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { scrollToId } from "@/lib/scroll";
import { LogoMark } from "./Logo";
import { DirectorPhone } from "./DirectorPhone";
import { SectionLabel } from "./Reveal";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative pt-24 pb-10 overflow-hidden" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5 text-[var(--text)]">
            <LogoMark className="w-24 h-24" />
            <p className="mt-6 text-sm text-[var(--muted)] max-w-sm">{t.footer.partner}</p>
          </div>
          <div id="footer-contacts" className="md:col-span-4 text-sm space-y-3" data-testid="footer-contacts">
            <div className="pb-2" data-testid="footer-contacts-title"><SectionLabel n="09">{t.nav.contacts}</SectionLabel></div>
            <a href="tel:+77000009307" data-testid="footer-phone-link" className="block font-display text-xl text-[var(--text)] hover:text-[var(--gold)] transition-colors">+7 700 000 93 07</a>
            <DirectorPhone id="footer" />
            <a href="mailto:toobaspanakurylys@bk.ru" data-testid="footer-email-link" className="block text-[var(--text)] hover:text-[var(--gold)] transition-colors break-all">toobaspanakurylys@bk.ru</a>
            <p className="text-[var(--muted)]" data-testid="footer-address"><span className="block text-xs uppercase tracking-[0.15em] text-[var(--gold)] mb-1">{t.footer.hq}</span>{t.req.rows[5].v}</p>
          </div>
          <div className="md:col-span-3 text-sm space-y-3 text-[var(--muted)]">
            <p>{t.req.rows[1].k} 001140001806</p>
            <a href="https://qazaqnet.kz" target="_blank" rel="noopener noreferrer" data-testid="footer-qazaqnet-link" className="block hover:text-[var(--gold)] transition-colors">{t.footer.source}</a>
            <button onClick={() => scrollToId("top")} data-testid="footer-top-button" className="inline-flex items-center gap-2 text-[var(--text)] hover:text-[var(--gold)] transition-colors">
              <ArrowUp className="w-4 h-4" /> {t.footer.top}
            </button>
          </div>
        </div>
        <div className="mt-20 font-display font-bold uppercase leading-none text-outline-soft text-[15vw] md:text-[12.5vw] tracking-[-0.03em] select-none whitespace-nowrap" aria-hidden="true">
          БАСПАНА
        </div>
        <div className="font-display text-[var(--gold)] tracking-[0.5em] text-xs md:text-lg uppercase mt-2" aria-hidden="true">Құрылыс · Инвест</div>
        <div className="mt-6 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-[var(--muted)]">
          <span>© 2026 {t.footer.company}. {t.footer.rights}</span>
          <span>{t.footer.city}</span>
        </div>
      </div>
    </footer>
  );
};
